import { useEffect } from 'react';

const GoogleAnalytics = ({ userId, eventType, page }) => {

  useEffect(() => {
    const trackAnalytics = () => {
      const timestamp = new Date().toISOString(); 

      if (window.gtag) {
        window.gtag('event', eventType, {
          event_category: 'User Interaction',
          event_label: page,
          user_id: userId,
          timestamp,
        });
      }
    };

    trackAnalytics();
  }, [userId, eventType, page]);

  return null; 
};

export default GoogleAnalytics;
